import React, { useEffect, useState } from 'react';
import { Modal, Table, Button, message } from 'antd';
import { fetchExpenses } from '../../../services/BillsExpensesService';
import { updateReimbursementAll } from '../../../../services/ReimbursementService';
import { useAuth } from '../../../../AuthProvider';

const LinkExpenseModal = ({ open, onClose, onSelect }) => {
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(false);
  const auth = useAuth();

  useEffect(() => {
    if (open && auth?.token) {
      setLoading(true);
      fetchExpenses(auth.token, auth.additionalUserInfo.companyId)
        .then(res => setExpenses(res.data || []))
        .catch(() => message.error('Failed to load expenses'))
        .finally(() => setLoading(false));
    }
  }, [open, auth?.token]);

  const handleSelect = async (expense) => {
    try {
      await updateReimbursementAll({ ...expense, paid: 'Y' }, auth.token);
      message.success('Expense marked as paid and linked!');
      onSelect(expense);
      onClose();
    } catch (e) {
      message.error('Failed to update expense');
    }
  };

  const columns = [
    { title: 'Supplier', dataIndex: 'supplierName', key: 'supplierName' },
    { title: 'Amount', dataIndex: 'claimedAmount', key: 'claimedAmount' },
    { title: 'Status', dataIndex: 'paid', key: 'paid', render: v => v === 'Y' ? 'Paid' : 'Unpaid' },
    { title: 'Action', key: 'action', render: (_, record) => <Button type="primary" onClick={() => handleSelect(record)}>Select</Button> },
  ];

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
      destroyOnClose
      title="Select Expense to Link"
    >
      <Table
        dataSource={expenses}
        columns={columns}
        rowKey="reimbursementId"
        loading={loading}
        pagination={{ pageSize: 8 }}
      />
    </Modal>
  );
};

export default LinkExpenseModal;
